import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { firstValueFrom } from 'rxjs';
import { environment } from 'src/environments/environment';

import { AttendeeDto } from '../models/attendee-dto';

@Injectable({
	providedIn: 'root',
})
export class AttendeesService {
	constructor(private httpClient: HttpClient, public auth: AngularFireAuth) {
		// do nothing
	}

	async addAttendee(attendee: AttendeeDto): Promise<AttendeeDto> {
		const user = await this.auth.currentUser;
		const token = await user?.getIdToken();

		const headers = new HttpHeaders({
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`,
		});

		return await firstValueFrom(this.httpClient
			.post<AttendeeDto>(`${environment.apiUrl}/api/attendees`, attendee, {
				headers: headers,
			}));
	}

	async getAttendeesBy(eventId?: string, page?: number, pageSize?: number): Promise<AttendeeDto[]> {
		const user = await this.auth.currentUser;
		const token = await user?.getIdToken();

		const headers = new HttpHeaders({
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`,
		});

		return await firstValueFrom(this.httpClient
			.get<AttendeeDto[]>(
				`${environment.apiUrl}/api/attendees
				?eventId=${eventId !== undefined ? eventId : ''}
				&page=${page}
				&pageSize=${pageSize}`,
				{
					headers: headers,
				}
			));
	}

	async getAttendeesByLength(eventId?: string): Promise<number> {
		const user = await this.auth.currentUser;
		const token = await user?.getIdToken();

		const headers = new HttpHeaders({
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`,
		});

		return await firstValueFrom(this.httpClient
			.get<number>(
				`${environment.apiUrl}/api/attendees/length
				?eventId=${eventId !== undefined ? eventId : ''}`,
				{
					headers: headers,
				}
			));
	}
}
